import React from 'react'
import styled from 'styled-components';
import Logo from '../Assets/Images/footlogo.png';
import Whatsapp from '../Assets/Images/whatsapp.png'
import Linkedin from '../Assets/Images/linkedin.png'
import phone from '../Assets/Images/call.png'
import email from '../Assets/Images/mail.png'
import location from '../Assets/Images/location.png'
const Footer = () => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const chennai = {
    phone:"044-42077634",
    email:"sales@reachemchemicals.com",
    location:"293, Sidco Industrial Estate, Ambattur North Phase, Chennai - 600 098.",
  };
  const overseas = {
    phone:"+1 647-985-7177",
    email:"meera@reachemchemicals.com",
    location:"600 Matheson Blvd W Unit 5, Mississauga, ON L5R 4C1.",
  };
  const bengaluru = {
    phone:"080 - 22126294",
    email:"sales@reachemchemicals.com",
    location:"No 37, 2nd Main, CKC Garden, Mission Road Cross, Bengaluru - 560 027.",
  };
  const social_media = [
    {
      link:"https://www.linkedin.com/company/reachem-chemicals/",
      img:Linkedin,
      title:"Linkedin",
    }
  ]
  return (
    <FooterSection>
      <div className='wrapper'>
        <div className='footer_align'>
          <div className='footer_1'>
            <h4>Chennai</h4>
            <ul>
            <li className='phone'><a href={"tel:"+chennai?.phone} title='Call Now'>{chennai?.phone}</a></li>
              <li className='email'><a href={"mailto:"+chennai?.email} title='Mail to'>{chennai?.email}</a></li>
              <li className='location'>{chennai?.location}</li>
            </ul>
          </div>
          <div className='footer_2'>
            <h4>Overseas Operations</h4>
            <ul>
            <li className='phone'><a href={"tel:"+overseas?.phone} title='Call Now'>{overseas?.phone}</a></li>
              <li className='email'><a href={"mailto:"+overseas?.email} title='Mail to'>{overseas?.email}</a></li>
              <li className='location'>{overseas?.location}</li>
            </ul>
          </div>
          <div className='footer_3'>
            <h4>Bengaluru</h4>
            <ul>
              <li className='phone'><a href={"tel:"+bengaluru?.phone} title='Call Now'>{bengaluru?.phone}</a></li>
              <li className='email'><a href={"mailto:"+bengaluru?.email} title='Mail to'>{bengaluru?.email}</a></li>
              <li className='location'>{bengaluru?.location}</li>
            </ul>
          </div>
          <div className='footer_4'>
            <div className='logo'>
              <img src={Logo} title='Reachem Chemicals' />
            </div>
            <div className='social_media'>
              {social_media?.map((e, i) => {
                return (
                  <a href={e?.link} key={i} target="_blank" title={e?.title}>
                    <img src={e?.img} alt={e?.title} />
                  </a>
                )
              })}
            </div>
          </div>
        </div>
      </div>
      <div className='copy_text'>
        <div className='wrapper'>
          <p>© {currentYear} Reachem. All rights reserved.</p>
        </div>
      </div>
      <div className='whatsapp'>
      <a href="https://api.whatsapp.com/send?phone=919884814008&amp;text=" title="Whatsapp Chat" target="_blank">
		<div class="whatsappme__button">
			<img src={Whatsapp} alt="Whatsapp Chat" />
		</div>
	</a>
      </div>
    </FooterSection>
  )
}

export default Footer;


const FooterSection = styled.section`
  
background: #7f8583;

display: inline-block;
width: 100%;

.footer_align {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 45px;
  padding: 50px 0;
}
.footer_align h4 {
    font-family: Helvetica;
    font-size: 26px;
    margin: 0 0 30px 0;
    font-weight: 600;
    position: relative;
    color: #fff;
    padding: 0 0 20px 0;
}
.footer_align h4:after {
    content: "";
    position: absolute;
    height: 4px;
    background: #fff;
    width: 120px;
    left: 0;
    bottom: 0;
}
.footer_align ul {
  line-height: 2.0;
  font-size: 16px;
  color: #fff;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.footer_align .logo img {
  width: 245px;
}
.footer_align ul li {
  padding: 0 0 0 28px;
  position: relative;
}
.footer_align ul li a {
  text-decoration: none;
  color: inherit;
}
.footer_align ul li.location::after {
  content: "";
  position: absolute;
  background: url(${location}) no-repeat;
  height: 18px;
    width: 18px;
    background-position: center left;
    top: 8px;
    left: 0;
    background-size: contain;
}
.footer_align ul li.phone::after {
  content: "";
  position: absolute;
  background: url(${phone}) no-repeat;
  height: 18px;
    width: 18px;
    background-position: center left;
    top: 8px;
    left: 0;
    background-size: contain;
}
.footer_align ul li.email::after {
  content: "";
  position: absolute;
  background: url(${email}) no-repeat;
  height: 18px;
    width: 18px;
    background-position: center left;
    top: 8px;
    left: 0;
    background-size: contain;
}

.social_media {
  display: flex;
  align-items: center;
  margin: 30px 0 0 0;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px 15px;
}

.copy_text {
    background: #4c504f;
}
.copy_text p {
    color: #fff;
    padding: 13px 0;
    text-align: center;
}
.whatsappme__button {
    position: fixed;
    z-index: 2;
    bottom: 20px;
    right: 20px;
    height: 60px;
    min-width: 60px;
    max-width: 95vw;
    background-color: #25d366;
    color: #fff;
    border-radius: 30px;
    box-shadow: 1px 6px 24px 0 rgba(7,94,84,.24);
    cursor: pointer;
    transition: background-color .2s linear;
    -webkit-tap-highlight-color: transparent;
}

@media screen and (max-width: 1200px) {
  .footer_align {
    display: grid;
    grid-template-columns: repeat(2,1fr);
    gap: 50px;
  }
}



@media screen and (max-width: 576px) {
  .footer_align {
    display: flex;
    flex-direction: column-reverse;
  }
  .footer_4 {
    width: 100%;
  }
  .footer_4 .logo {
    width: 100%;
  }
  .footer_4 .logo img {
    margin: auto;
    display: flex;
    width: 180px;
  }
}














`;